var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "12px",
    viewBox: "0 0 10 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Delete") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.85714286,4 L7.85714286,10.6666667 L2.14285714,10.6666667 L2.14285714,4 L7.85714286,4 M6.78571429,0 L3.21428571,0 L2.5,0.666666667 L0,0.666666667 L0,2 L10,2 L10,0.666666667 L7.5,0.666666667 L6.78571429,0 Z M9.28571429,2.66666667 L0.714285714,2.66666667 L0.714285714,10.6666667 C0.714285714,11.4 1.35714286,12 2.14285714,12 L7.85714286,12 C8.64285714,12 9.28571429,11.4 9.28571429,10.6666667 L9.28571429,2.66666667 Z",
    id: "path-red-trash"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-70.0%",
    y: "-41.7%",
    width: "240.0%",
    height: "216.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ALLE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base_Card_Details",
    transform: "translate(-352.000000, -10.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    transform: "translate(352.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-red-trash"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#CA0037",
    xlinkHref: "#path-red-trash"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinRed);
export default __webpack_public_path__ + "static/media/bin_red.5689ad3ef628b85af8a04615402440a5.svg";
export { ForwardRef as ReactComponent };